import { useEffect, useState, useRef } from "react";

const useTrackedProperty = (object, property) => {
  // Gracefully handle undefined/null objects
  const initialValue = object && typeof object === 'object' ? object[property] : undefined;
  const [propertyValue, setPropertyValue] = useState(initialValue);
  const prevValue = useRef(initialValue);

  useEffect(() => {
    if (!object || typeof object !== 'object') {
      if (prevValue.current !== undefined) {
        prevValue.current = undefined;
        setPropertyValue(undefined);
      }
      return;
    }

    const currentValue = object[property];
    if (prevValue.current !== currentValue) {
      setPropertyValue(currentValue);
      prevValue.current = currentValue;
    }
  }, [object, property]);

  return propertyValue;
};

export default useTrackedProperty;